import { Stack } from 'expo-router';

export default function TvLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: false, // No headers for TV displays
        gestureEnabled: false, // Disable swipe gestures
        animation: 'none', // No transition animations
      }}
    >
      <Stack.Screen 
        name="[gymId]" 
        options={{
          headerShown: false,
          gestureEnabled: false,
        }}
      />
    </Stack>
  );
}